import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { Error as StaticError } from 'gandi.react-static-pages';
var styles = {
  "root": "Error-root_2a1D1"
};
function Error(_ref) {
  var className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StaticError, _extends({}, extraProps, {
    className: clsx(styles.root, className)
  }));
}
export default Error;